/**
 * 今日到店用户 · 列表列定义
 * ------------------------------------------------------------------
 * 列定义外置是「拆大文件」的主要手法（重构方案 §4.3）：页面文件只留
 * 取数与组合，列定义、格式化、宽度策略集中在这里，便于复用与走查。
 *
 * 约定：
 *   numeric 数字列（右对齐 + 等宽）；unit 单位（浅色小字后缀）；
 *   format 取值格式化统一用 utils/format.js，不在列里各写逻辑。
 */
import React from 'react';

import { formatNumber } from '../../../utils/format';

export const visitColumns = [
  { title: '会员昵称', dataIndex: 'nickName', width: 140 },
  {
    title: '到店行为时间线',
    dataIndex: 'timeline',
    /* BFF 已把事件拼成「事件 时间 → 事件 时间」整串下发（源 eventName 含「 · 器械名」后缀），
       与 H5 一样整串直出、不本地再拆；此前误按 {time,label} 数组读，恒渲染 '--'。 */
    render: (v) => (typeof v === 'string' && v.trim() ? v : '--'),
  },
  {
    title: '本月到店(天)',
    dataIndex: 'monthVisitDays',
    width: 110,
    numeric: true,
    /* 三态：null = 本月窗口没算出来，渲染 '--'，不得吞 0；
       不用 monthVisitNum —— 源 monthlyVisitCount 是恒 0 占位（metaspace TODO），H5 适配层也不透传 */
    format: (v) => formatNumber(v),
  },
  {
    title: '操作',
    key: 'op',
    width: 100,
    render: (r) => (
      <a
        href={`/litta-palmer/user/record?id=${r.userId}`}
        target="_blank"
        rel="noreferrer"
      >
        会员详情
      </a>
    ),
  },
];

export default visitColumns;
